export default "__VITE_ASSET__C1kl7q2O__"